(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
  this.header = document.querySelector('.section-header');

  this.headerIsAlwaysSticky =
    this.getAttribute('data-sticky-type') === 'always' ||
    this.getAttribute('data-sticky-type') === 'reduce-logo-size';

  this.headerBounds = {};
  this.desktopOnly = this.getAttribute('data-desktop-only') === 'true';
  this.desktopMQ = window.matchMedia('(min-width: 990px)');

  this.setHeaderHeight();
  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  if (this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-sticky');
  }

  this.currentScrollTop = 0;
  this.preventReveal = false;
  this.predictiveSearch = this.querySelector('predictive-search');

  this.onScrollHandler = this.onScroll.bind(this);
  this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);

  this.createObserver();

  /* === Fixed fallback: activate when "always" is selected (and desktop-only matches) === */
  this.enableFixedFallback = this.headerIsAlwaysSticky;
  const shouldFixNow = this.enableFixedFallback && (!this.desktopOnly || this.desktopMQ.matches);
  this.applyFixedFallback(shouldFixNow);

  // Keep padding aligned on viewport resize
  window.addEventListener('resize', () => {
    if (this.classList.contains('use-fixed')) this.setHeaderHeight();
  });

  // 🔎 Recompute when the inner header’s size changes (fonts, logo, announcement bar, etc.)
  const inner = this.querySelector('.header');
  if (inner && 'ResizeObserver' in window) {
    this._ro = new ResizeObserver(() => {
      if (this.classList.contains('use-fixed')) this.setHeaderHeight();
    });
    this._ro.observe(inner);
  }

  // Final pass after everything is fully loaded
  window.addEventListener('load', () => {
    if (this.classList.contains('use-fixed')) this.setHeaderHeight();
  });
}

disconnectedCallback() {
  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.removeEventListener('scroll', this.onScrollHandler);
  if (this._ro) this._ro.disconnect(); // cleanup the observer
}


    /* Measure the real header row inside the custom element */
    measureHeaderHeight() {
      const inner = this.querySelector('.header');
      return inner ? inner.offsetHeight : this.offsetHeight;
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.measureHeaderHeight()}px`);
    }

    applyFixedFallback(on) {
      if (on) {
        this.classList.add('use-fixed');                                   // fixes <sticky-header> at top
        document.documentElement.style.setProperty('--header-height', `${this.measureHeaderHeight()}px`);
        document.body.classList.add('header-fixed-padding');                // push page down by header height
      } else {
        this.classList.remove('use-fixed');
        document.body.classList.remove('header-fixed-padding');
        document.documentElement.style.setProperty('--header-height', `0px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.desktopOnly && !this.desktopMQ.matches) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal && this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
